var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 11.9466C7.56201 11.9474 7.12812 11.8619 6.72317 11.6948C6.31823 11.5278 5.95017 11.2827 5.64004 10.9733L0.193376 5.52664C0.0678397 5.4011 -0.00268555 5.23084 -0.00268555 5.05331C-0.00268555 4.87577 0.0678397 4.70551 0.193376 4.57997C0.318911 4.45444 0.489174 4.38391 0.666709 4.38391C0.844243 4.38391 1.01451 4.45444 1.14004 4.57997L6.58671 10.0266C6.96171 10.4012 7.47004 10.6115 8.00004 10.6115C8.53004 10.6115 9.03837 10.4012 9.41338 10.0266L14.86 4.57997C14.9856 4.45444 15.1558 4.38391 15.3334 4.38391C15.5109 4.38391 15.6812 4.45444 15.8067 4.57997C15.9322 4.70551 16.0028 4.87577 16.0028 5.05331C16.0028 5.23084 15.9322 5.4011 15.8067 5.52664L10.36 10.9733C10.0499 11.2827 9.68186 11.5278 9.27691 11.6948C8.87197 11.8619 8.43808 11.9474 8.00004 11.9466Z",
    fill: "#64748B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_1104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropdown);
export default __webpack_public_path__ + "static/media/ic_dropdown.232a7e33fa098e933474d0dd3d3f43f1.svg";
export { ForwardRef as ReactComponent };